var productCardMarkup = 
  `{{#product}} 

	<a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>
		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div><button class="swym-is-button">
		<div class="swym-title swym-title-1">
			{{dt}}
		</div></button>
		<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
			{{variantinfo}}
		</div>
		<div class="swym-product-price swym-text swym-text-1">
			<div class="swym-product-final-price swym-value">
				{{cu}}{{pr}}
			</div>
        </div>
        <div id="{{epi}}"></div>
		<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
			{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
		</button>
    </a> 
       {{/product}}`;

function getProductDetail(p) {
      const endpointUrl = p.du + '.json'
      
      // Make a GET request to the JSON endpoint using fetch
      fetch(endpointUrl)
        .then(response => {
          // Check if the request was successful (status code 200)
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          // Parse the JSON data from the response
          return  response.json();
        })
        .then(productData => {
    		var wishlistContentsContainer = document.querySelector(".swym-wishlist-grid");

            p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
  			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
  			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
            p.variantOptions = getVariantOptions(productData)

           var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
    			product: p
    		});
    		if(wishlistContentsContainer){
    			wishlistContentsContainer.innerHTML += productCardsMarkup;
                var optionsContainer = document.getElementById(p.epi);

                 optionsContainer.appendChild(p.variantOptions);
    			attachClickListeners();
    		} else{
    		  console.log("Container not found, Wishlist Page element not found");
    		}
        })
        .catch(error => {
          // Handle errors during the fetch
          console.error('Error fetching data:', error);
        });
}

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function getVariantOptions(productData){
  // Get unique options for each dropdown
  var optionsWrapper = document.createElement('div');
  var uniqueOption1 = [...new Set(productData.product.variants.map(variant => variant.option1))];
  var uniqueOption2 = [...new Set(productData.product.variants.map(variant => variant.option2))];
  
  // Populate option1 dropdown
  if(uniqueOption1){
    var option1Dropdown = document.createElement('select');
    
    uniqueOption1.forEach(option => {
      var optionElement = document.createElement('option');
      optionElement.value = option;
      optionElement.textContent = option;
      option1Dropdown.appendChild(optionElement);

      // Set as active option if variant ID matches
      /*if (selectedVariantId && variantsData.find(variant => variant.option1 === option && variant.id === selectedVariantId)) {
        optionElement.selected = true;
      }*/
    });
    optionsWrapper.appendChild(option1Dropdown);
  }

  // Populate option2 dropdown
  if(uniqueOption2){
    var option2Dropdown = document.createElement('select');

    uniqueOption2.forEach(option => {
      var optionElement = document.createElement('option');
      optionElement.value = option;
      optionElement.textContent = option;
      option2Dropdown.appendChild(optionElement);
      // Set as active option if variant ID matches
      /*if (selectedVariantId && variantsData.find(variant => variant.option2 === option && variant.id === selectedVariantId)) {
        optionElement.selected = true;
      }*/
    });
    optionsWrapper.appendChild(option2Dropdown);
  }
  
  return optionsWrapper;
}

// Function to update the add to cart button
function updateAddToCartButton(selectedVariant) {
  // Code to update the add to cart button with the selected variantId
  // You need to implement this based on your specific HTML structure and requirements
  var addToCartButton = document.getElementById('add-to-cart-button');
  addToCartButton.dataset.variantId = selectedVariant.id;
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

async function swymRenderWishlist(swat) {
  var grid = document.querySelector(".swym-wishlist-grid");
  grid.innerHTML = "";
	// Get wishlist items
	swat.fetch(function(products) {
		var formattedWishlistedProducts = products.map(function(p) {
            productData = getProductDetail(p);
  		});
	})

  // Event listener for option changes
  document.addEventListener('change', function (event) {
    if (event.target.classList.contains('variant-option')) {
      // Get selected options
      var selectedOption1 = document.getElementById('option1-dropdown').value;
      var selectedOption2 = document.getElementById('option2-dropdown').value;
  
      // Find the selected variant
      var selectedVariant = variantsData.find(variant =>
        variant.option1 === selectedOption1 && variant.option2 === selectedOption2
      );
  
      // Update the add to cart button
      if (selectedVariant) {
        updateAddToCartButton(selectedVariant);
      }
    }
  });
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		// console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}